import React, { FC } from 'react';

import Text from '@ingka/text';
import {
  LOCAL_DATA_PRIVACY_POLICY_LINK,
  PRIVACY_POLICY_LINK,
} from '../../utils/constants';
import { Stack } from '@mui/material';
import useTranslation from '../../hooks/useTranslation';

const PrivacyStatement: FC = () => {
  const t = useTranslation();
  return (
    <Stack sx={{ p: 2 }}>
      <Text>{t('privacy.header')}</Text>

      <Text>
        <b>{t('privacy.personalDataBold')}</b> {t('privacy.personalData')}
      </Text>
      <Text>
        <b>{t('privacy.purposeBold')}</b> {t('privacy.purpose')}
      </Text>
      <Text>
        <b>{t('privacy.legalBold')}</b> {t('privacy.legal')}
      </Text>
      <Text>
        <b>{t('privacy.dataBold')}</b> {t('privacy.data')}
      </Text>
      <Text>
        <b>{t('privacy.controllerBold')}</b>
        {t('privacy.controller')}
      </Text>
      <Text>{t('privacy.controllerAdvice')}</Text>
      <Text>
        <a href={LOCAL_DATA_PRIVACY_POLICY_LINK}>
          {LOCAL_DATA_PRIVACY_POLICY_LINK}
        </a>
      </Text>
      <Text>{t('privacy.footer')}</Text>
      <Text>{t('privacy.rights')}</Text>
      <Text>
        <a style={{ wordBreak: 'break-word' }} href={PRIVACY_POLICY_LINK}>
          {PRIVACY_POLICY_LINK}
        </a>
      </Text>
    </Stack>
  );
};

export default PrivacyStatement;
